import { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";

import sub0102 from "../assets/sub0102-img01.png";

function Vision() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      offset: 100,
      easing: "ease-in-out",
      once: false,
    });

    window.addEventListener("scroll", () => {
      AOS.refresh();
    });
  }, []);

  return (
    <div>
      <section className="sec-wrap">
        <section className="sec-centent">
          <div id="sub" className="mission">
            <div className="col-a cont-wr">
              <div className="wr">
                <div className="cont-tit">
                  <h2 className="big">
                    고객의 행복한 미래를 위해
                    <br className="pc-only" /> 끊임없이 도전하고 있습니다.
                  </h2>
                </div>
                <div data-aos="fade" data-aos-delay="100" data-aos-duration="500">
                  <div className="ls-box">
                    <div className="cell-box">
                      <h3>Vision</h3>
                      <p className="slg">
                        TOTAL SOLUTION PROVIDER <br className="pc-only" />
                        <strong>FOR TOMORROW, JENIX</strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="cont-wr">
              <div className="wr">
                <div className="cont-tit">
                  <h2>프로페셔널리즘 (Professionalism)</h2>
                  <p>
                    농림 정보화 분야에서 전문성을 확보하여 지속적인 농업, 농촌 정보화 솔루션을 개발 보급하여 농림 정보화 발전에 기여하며
                    <br className="pc-only" />
                    농림 정보화 전문기업으로서 안정적인 경영과 사업 추진 역량 강화로 고객에게 효율적인 최적의 정보 서비스를 제공합니다.
                    <br className="pc-only" />
                    또한 다양한 이해관계자와 우리 모두의 미래를 위한 지속 가능한 가치를 제공하기 위하여
                    <br className="pc-only" />
                    혁신, 협력, 실행을 통해 지속성장하는 초일류 회사를 지향합니다.
                  </p>
                </div>
                <div className="center">
                  <div className="img center" data-aos="fade-down" data-aos-delay="100" data-aos-duration="500">
                    <img src={sub0102} alt="초고층빌딩이미지" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
}

export default Vision;
